<template>
  <!-- image="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg" -->
  <v-app-bar 
    prominent
    theme="dark"
    color="#070F26"
    class="justify-space-between"
  >
    <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    <v-toolbar-title>{{ selectedItemTitle }}</v-toolbar-title>
    <v-spacer></v-spacer>
    <div class="d-flex mr-3 aling-center">
      <lenguage-selector
        v-model="currentLanguage"
        @change="handleLanguageChange"
        mode="dark"
      />
      <v-img
        :src="nttDataLogo"
        max-height="40"
        min-width="200"
        contain
        style="left: 8%;" 
      ></v-img>
    </div>
  </v-app-bar>

  <!-- image="https://cdn.vuetifyjs.com/images/backgrounds/bg-2.jpg" -->
  <v-navigation-drawer 
    v-model="drawer" 
    color="#070F26"
    theme="dark"
  >
    <v-divider></v-divider>
    <v-list>
      <template v-for="(item, index) in items" :key="item.divider ? 'divider-' + index : item.value">
        <!-- Render a separator divider (admin section) -->
        <div v-if="item.divider" class="px-4 my-2">
          <v-divider color="gray" :thickness="2" opacity="1" style="width: 95%;" />
        </div>

        <!-- Render the list item -->
        <template v-else>
          <v-list-item
            @click="navigateTo(item)"
            :prepend-icon="item.icon"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>

          <!-- Render a divider after each non-divider item except the last one -->
          <v-divider v-if="index < items.length - 1 && !items[index + 1]?.divider" />
        </template>
      </template>
    </v-list>
    <template #append>
      <div class="pa-4">
        <v-btn
          block
          variant="tonal"
          prepend-icon="mdi-logout"
          @click="handleLogout"
        >
          {{ $t('authentication.logout') }}
        </v-btn>
      </div>
    </template>
  </v-navigation-drawer>
</template>

<script>
import nttDataLogo from '@/assets/ntt_data_logo.png'; // Import the logo
import LenguageSelector from '@/components/LenguageSelector.vue';
import { logout_user, get_current_user_from_storage } from '@/api';


export default {
  components: {
    LenguageSelector
  },
  data: () => ({
    drawer: true,
    nttDataLogo: nttDataLogo,
    currentLanguage: 'en'
  }),
  computed: {
    isAdmin() {
      const user = get_current_user_from_storage();
      return user?.role_id === 'admin' || user?.role_id === 'super_admin';
    },
    selectedItemTitle() {
      // Find the item corresponding to the current route name or default to 'Home'
      const currentRoute = this.items.find(item => item.value === this.$route.name);
      return currentRoute ? currentRoute.title : 'Home';
    },
    items() {
        const baseItems = [
          { title: this.$t('sidebar.personas'), value: 'persona', icon: 'mdi-account' },
          { title: this.$t('sidebar.chat'), value: 'chat', icon: 'mdi-message' },
          { title: this.$t('sidebar.interviewPersonas'), value: 'interview', icon: 'mdi-clipboard-list' },
          { title: this.$t('sidebar.focusGroup'), value: 'focus-group', icon: 'mdi-account-group' },
          { title: this.$t('sidebar.dashboard'), value: 'dashboard', icon: 'mdi-view-dashboard' },
          { title: this.$t('sidebar.generatePersonas'), value: 'generate-personas', icon: 'mdi-creation' },
        ];

        if (this.isAdmin) {
          baseItems.push({ divider: true });
          baseItems.push({ title: this.$t('sidebar.personaManagement'), value: 'persona-management', icon: 'mdi-account-cog-outline' });
          baseItems.push({ title: this.$t('sidebar.promptManagement'), value: 'prompt-management', icon: 'mdi-file-document-edit-outline' });
        }

        return baseItems;
      }
  },
  methods: {
    navigateTo(item) {
      // Navigate based on the selected item's route value
      this.$router.push({ name: item.value });
      //this.drawer = false; // Close the drawer after navigation
    },
    handleLanguageChange(languageCode) {
        this.currentLanguage = languageCode
        this.$i18n.locale = languageCode

        localStorage.setItem('appLanguage', languageCode)
    },
    handleLogout() {
      logout_user();
      this.$router.push({ name: 'login' });
    }
  },
  mounted() {
    const savedLanguage = localStorage.getItem('appLanguage')
      if (savedLanguage) {
        this.currentLanguage = savedLanguage
        this.$i18n.locale = savedLanguage
      }
    }
}
</script>

<style scoped>
/* Target the navigation drawer component */

/* .v-navigation-drawer {
  border-top-color: white; 
  border-top-style: solid; 
  border-top-width: 1px;   
} 
*/

</style>
